import React from 'react';
import { createIcon } from './create-icon';
import './icon-paperclip.scss';

export const IconPaperclip = createIcon(<div className="icon-paperclip" />);
export const IconPaperclipWhite = createIcon(<div className="icon-paperclip white" />);
